module.exports = "- Write XML inside JS file\n\n- Compiled down to ES3-compatible JS\n\n- Work abandoned, idea resurrected after React merged in\n\n- Result is JSX\n\n- Recommended by React team\n\n- Widely adopted by the community\n\n- Continues to be a polarizing issue"


//////////////////
// WEBPACK FOOTER
// ./src/slides/07_jsx/notes_2.md
// module id = 1500
// module chunks = 0